/** Confirmed outcomes invalidate owned reads; historical receipts never replace current rows. */
const listeners = new Set<(userId: string) => void>();
export function subscribeAgendaChanges(listener: (userId: string) => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
export function publishAgendaRefresh(userId: string) { listeners.forEach(listener => listener(userId)); }
